<template>
  <div>
    <form>
      <v-layout
        wrap
        align-center
        justify-space-between
      >
        <v-flex
          xs12
          md5
        >
          <v-select
            v-model="form.disciplinarne_tresty"
            v-validate="'required'"
            :disabled="form.closed"
            :items="selects.disciplinarne_tresty"
            label="Disciplinárne tresty (počet - časové obdobie 24  mesiacov pred hodnotením)"
            name="Disciplinárne tresty (počet - časové obdobie 24  mesiacov pred hodnotením)"
            :error-messages="errors.collect('Disciplinárne tresty (počet - časové obdobie 24  mesiacov pred hodnotením)')"
            required
            append-icon="mdi-information-outline"
            @click:append="appendIconCallback('disciplinarne_tresty')"
          />
        </v-flex>

        <v-flex
          xs12
          md5
        >
          <v-select
            v-model="form.disciplinarne_odmeny"
            v-validate="'required'"
            :disabled="form.closed"
            :items="selects.disciplinarne_odmeny"
            label="Disciplinárne odmeny (počet - časové obdobie 24  mesiacov pred hodnotením)"
            name="Disciplinárne odmeny (počet - časové obdobie 24  mesiacov pred hodnotením)"
            :error-messages="errors.collect('Disciplinárne odmeny (počet - časové obdobie 24  mesiacov pred hodnotením)')"
            required
            append-icon="mdi-information-outline"
            @click:append="appendIconCallback('disciplinarne_odmeny')"
          />
        </v-flex>
      </v-layout>

      <v-select
        v-model="form.zamietnute_ziadosti_o_podm"
        v-validate="'required'"
        :disabled="form.closed"
        :items="selects.zamietnute_ziadosti_o_podm"
        label="Zamietnuté žiadosti o podmienečné prepustenie (historický údaj z minulého časového obdobia max.  5 rokov pred dátumom hodnotenia)"
        name="Zamietnuté žiadosti o podmienečné prepustenie (historický údaj z minulého časového obdobia max.  5 rokov pred dátumom hodnotenia)"
        :error-messages="errors.collect('Zamietnuté žiadosti o podmienečné prepustenie (historický údaj z minulého časového obdobia max.  5 rokov pred dátumom hodnotenia)')"
        required
        append-icon="mdi-information-outline"
        @click:append="appendIconCallback('zamietnute_ziadosti_o_podm')"
      />

      <v-select
        v-model="form.prijatie_zodpovednosti"
        v-validate="'required'"
        :disabled="form.closed"
        :items="selects.prijatie_zodpovednosti"
        label="Prijatie zodpovednosti za páchanú trestnú činnosť"
        name="Prijatie zodpovednosti za páchanú trestnú činnosť"
        :error-messages="errors.collect('Prijatie zodpovednosti za páchanú trestnú činnosť')"
        required
        append-icon="mdi-information-outline"
        @click:append="appendIconCallback('prijatie_zodpovednosti')"
      />

      <v-select
        v-model="form.predatorske_spravanie"
        v-validate="'required'"
        :disabled="form.closed"
        :items="selects.predatorske_spravanie"
        label="Predátorské správanie"
        name="Predátorské správanie"
        :error-messages="errors.collect('Predátorské správanie')"
        required
        append-icon="mdi-information-outline"
        @click:append="appendIconCallback('predatorske_spravanie')"
      />

      <v-select
        v-model="form.plnenie_programu"
        v-validate="'required'"
        :disabled="form.closed"
        :items="selects.plnenie_programu"
        label="Plnenie programu zaobchádzania"
        name="Plnenie programu zaobchádzania"
        :error-messages="errors.collect('Plnenie programu zaobchádzania')"
        required
        append-icon="mdi-information-outline"
        @click:append="appendIconCallback('plnenie_programu')"
      />

      <v-select
        v-model="form.rodina_a_vztahy"
        v-validate="'required'"
        :disabled="form.closed"
        :items="selects.rodina_a_vztahy"
        label="Rodina a vzťahy počas aktuálneho výkonu trestu odňatia slobody"
        name="Rodina a vzťahy počas aktuálneho výkonu trestu odňatia slobody"
        :error-messages="errors.collect('Rodina a vzťahy počas aktuálneho výkonu trestu odňatia slobody')"
        required
        append-icon="mdi-information-outline"
        @click:append="appendIconCallback('rodina_a_vztahy')"
      />

      <v-layout
        row
        wrap
        pt-5
      >
        <v-flex xs12>
          <v-subheader
            class="pl-0"
          >
            Expertné posúdenie - pravdepodobnosť, že posudzovaná osoba sa dopustí trestnej činnosti do 2 rokov od prepustenia
          </v-subheader>
          <v-slider
            v-model="form.expertne_posudenie"
            :tick-labels="selects.expertne_posudenie"
            always-dirty
            min="0"
            max="3"
            ticks="always"
            :color="color"
            :readonly="form.closed"
            append-icon="mdi-information-outline"
            @click:append="appendIconCallback('expertne_posudenie')"
          />
        </v-flex>
      </v-layout>

      <v-divider class="mt-10" />

      <v-textarea
        v-model="form.poznamky"
        :disabled="form.closed"
        label="Poznámky a doplňujúce informácie"
        auto-grow
        rows="1"
      />

      <v-layout
        v-if="!form.closed"
        pt-5
      >
        <v-btn
          dark
          color="primary"
          @click="updateItem"
        >
          Uložiť
        </v-btn>
        <div class="flex-grow-1" />
        <v-btn
          dark
          color="red"
          @click="closeItem"
        >
          Uložiť a uzatvoriť
        </v-btn>
      </v-layout>
      <v-layout
        v-else
        pt-5
      >
        <div class="flex-grow-1" />
        <v-btn
          v-if="!craItem.closed"
          dark
          color="green"
          @click="openItem"
        >
          Otvoriť
        </v-btn>
      </v-layout>
    </form>
    <v-snackbar
      v-model="snackbar_saved"
      color="success"
      :timeout="3000"
    >
      Uložené
      <v-btn
        text
        @click="snackbar_saved = false"
      >
        Zavrieť
      </v-btn>
    </v-snackbar>
    <v-snackbar
      v-model="snackbar_error"
      color="error"
      :timeout="5000"
    >
      Chyba
    </v-snackbar>

    <v-dialog
      v-model="dialog"
      width="800px"
    >
      <v-card>
        <v-toolbar
          dark
          color="indigo"
        >
          <v-btn
            icon
            dark
            @click="dialog = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>{{ dialog_item.nazov }}</v-toolbar-title>
          <div class="flex-grow-1" />
        </v-toolbar>
        <v-card>
          <v-card-title>
            <span class="headline">Charakteristika</span>
          </v-card-title>
          <v-card-text
            v-for="(item, index) in dialog_item.charakteristika"
            :key="index"
          >
            {{ item }}
          </v-card-text>
        </v-card>
        <v-card>
          <v-card-title>
            <span class="headline">Zdroj</span>
          </v-card-title>
          <v-card-text
            v-for="(item, index) in dialog_item.zdroj"
            :key="index"
          >
            {{ item }}
          </v-card-text>
        </v-card>
        <v-card>
          <v-card-title>
            <span class="headline">Príklad</span>
          </v-card-title>
          <v-card-text
            v-for="(item, index) in dialog_item.priklad"
            :key="index"
          >
            {{ item }}
          </v-card-text>
        </v-card>
        <v-card>
          <v-card-title>
            <span class="headline">Poznámka</span>
          </v-card-title>
          <v-card-text
            v-for="(item, index) in dialog_item.poznamka"
            :key="index"
          >
            {{ item }}
          </v-card-text>
        </v-card>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Vue from "vue";
import { APIService } from "@/http/APIService.js";
import VeeValidate, { Validator } from "vee-validate";
import sk from "vee-validate/dist/locale/sk";

Vue.use(VeeValidate);
Validator.localize("sk", sk);

const apiService = new APIService();

export default {
  $_veeValidate: {
    validator: "new"
  },
  data: () => ({
    snackbar_saved: false,
    snackbar_error: false,
    dialog: false,
    dialog_item: {
      nazov: "",
      charakteristika: [],
      zdroj: [],
      poznamka: [],
      priklad: []
    },

    form: {
      id: null,
      skore: 0,
      disciplinarne_tresty: "",
      disciplinarne_odmeny: "",
      zamietnute_ziadosti_o_podm: "",
      prijatie_zodpovednosti: "",
      predatorske_spravanie: "",
      plnenie_programu: "",
      rodina_a_vztahy: "",
      expertne_posudenie: "0"
    },

    craItem: {},

    selects: {
      disciplinarne_tresty: ["0", "1", "2-3", "4 a viac"],
      disciplinarne_odmeny: ["0", "1 a viac", "nehodnotiteľné"],

      zamietnute_ziadosti_o_podm: [
        "odsúdenému súd zamietol žiadosť o podmienečné prepustenie",
        "odsúdenému súd nezamietol žiadosť o podmienečné prepustenie"
      ],

      prijatie_zodpovednosti: [
        "plne akceptuje svoju zodpovednosť za kriminálne správanie",
        "akceptuje nejakú zodpovednosť ale minimalizuje (bagatelizuje) a/alebo racionalizuje (zdôvodňuje)",
        "odmieta akúkoľvek zodpovednosť, obviňuje iných a okolnosti"
      ],

      predatorske_spravanie: [
        "nie je manipulatívny ani vykorisťovateľský vo vzťahu k ostatným odsúdeným, zamestnancom ZVJS, ostatným osobám, nezaujíma ho využívanie iných pre vlastné záujmy",
        "prejavuje určité kriminálne hodnoty a postoje (napr. „iba silný prežije“ a pod.), ale zjavne neťaží  z ostatných pre svoj vlastný prospech",
        "vydiera alebo manipuluje ostatných pre svoj vlastný prospech (cela, peniaze, strava, tabak, káva a pod.) bez ohľadu na ich práva a potreby"
      ],

      plnenie_programu: [
        "odsúdený plní program zaobchádzania",
        "odsúdený čiastočne plní program zaobchádzania",
        "odsúdený neplní program zaobchádzania",
        "nehodnotiteľné"
      ],

      rodina_a_vztahy: [
        "udržiava kontakt s rodinnými príslušníkmi a/alebo inými príp. blízkymi osobami, pričom tento kontakt možno charakterizovať ako intenzívny a pravidelný",
        "udržiava kontakt s rodinnými príslušníkmi a/alebo inými príp. blízkymi osobami",
        "nemá žiadny kontakt s rodinnými príslušníkmi a/alebo inými príp. blízkymi osobami"
      ],

      expertne_posudenie: ["nehodnotené", "malá", "stredná", "vysoká"]
    },

    manual: {
      disciplinarne_tresty: {
        nazov:
          "Disciplinárne tresty (počet - časové obdobie 24  mesiacov pred hodnotením)",
        priklad: [],
        charakteristika: [
          "Uvádza sa počet disciplinárnych trestov právoplatne uložených za posledných 24 mesiacov aktuálneho výkonu trestu (aj keď počas celého výkonu trestu má odsúdený uložených viac disciplinárnych trestov). Zarátava sa aj disciplinárny trest s podmienečným odkladom. Nezarátavajú sa zahladené disciplinárne tresty."
        ],
        poznamka: ["Rozhodujúcim termínom je dátum uloženia rozhodnutia."],
        zdroj: ["Aplikácia VVVT – disciplinárne konanie."]
      },

      disciplinarne_odmeny: {
        nazov:
          "Disciplinárne odmeny (počet - časové obdobie 24  mesiacov pred hodnotením)",
        poznamka: [],
        charakteristika: [
          "Uvádza sa počet disciplinárnych odmien právoplatne udelených za posledných 24 mesiacov aktuálneho výkonu trestu aj v prípade, že odsúdený je vo výkone trestu dlhšie.",
          "Riadok „nehodnotiteľné“ uvádzame pri odsúdenom, ktorý má trest kratší ako 24 mesiacov a nebola mu udelená  žiadna disciplinárna odmena  V tomto riadku uvádzame aj odsúdeného, ktorý zo zdravotných dôvodov nie je schopný získať odmenu (vážne zdravotné obmedzenia, diagnózy...).",
          "Riadok  „0: uvádzame pri odsúdenom, ktorý je vo VT dlhšie ako 24 mesiacov a nebola mu udelená žiadna disciplinárna odmena."
        ],
        zdroj: ["Aplikácia VVVT – disciplinárne konanie."],
        priklad: [
          "1. Odsúdený je vo výkone trestu 9 mesiacov. Z tento čas mu nebola udelená žiadna disciplinárna odmena. V CRA-CR a CRA-RU sa mu označí riadok „nehodnotiteľné“.",
          "2. Odsúdený je vo VT 3 roky. Počas tejto doby mu nebola udelená disciplinárna odmena. Má však zdravotnú klasifikáciu „F“ kvôli svalovej dystrofii. V CRA-CR a CRA-RU sa mu označí riadok „nehodnotiteľné“.",
          "3. Odsúdený je vo VT 2 roky aj 4 mesiace. Počas tejto doby mu nebola udelená žiadna disciplinárna odmena. Nemá žiadne zdravotné obmedzenie.  V CRA-CR a CRA-RU sa mu označí riadok„0“."
        ]
      },

      zamietnute_ziadosti_o_podm: {
        nazov:
          "Zamietnuté žiadosti o podmienečné prepustenie (historický údaj z minulého časového obdobia max.  5 rokov pred dátumom hodnotenia)",
        priklad: [],
        charakteristika: [
          "Zarátavajú sa žiadosti o PP, ktoré si odsúdený podal v aktuálnom výkone trestu."
        ],
        poznamka: [
          "Na účely stanovenia resocializačnej prognózy sa stiahnutie žiadosti odsúdeným považuje za zamietnutie žiadosti o PP."
        ],
        zdroj: [
          "Aplikácia VVVT - ďalšie záznamy - hodnotenia a návrhy na premiestnenie - rozhodnutie súdu."
        ]
      },

      prijatie_zodpovednosti: {
        nazov: "Prijatie zodpovednosti za páchanú trestnú činnosť",
        poznamka: [],
        charakteristika: [
          "- V prípade, že je opakovane odsúdený za tú istú trestnú činnosť, neuvádzame  „plne akceptuje zodpovednosť za kriminálne správanie“, i keď to odsúdený tvrdí. Hodnotiteľ zváži medzi zvyšnými dvoma možnosťami.",
          "- Ak akceptuje zodpovednosť za spáchaný skutok, ale nie je stotožnený s výškou trestu (vrátane úmyslu podať mimoriadny opravný prostriedok) alebo svoje konanie zdôvodňuje okolnosťami a externými vplyvmi, v CRA-CR a CRA-RU sa mu označí riadok „akceptuje nejakú zodpovednosť ale minimalizuje (bagatelizuje) a/alebo racionalizuje (zdôvodňuje)“."
        ],
        zdroj: [
          "Osobné pohovory, poznatky od blízkych, korešpondencia, psychologické vyšetrenie, iné záznamy v aplikácii VVVT."
        ],
        priklad: [
          "1. Odsúdený  je vo VT za krádež peňaženky s finančným obnosom. Trestný čin priznáva, no obhajuje tým, že je nezamestnaný, bez stáleho príjmu a musí živiť rodinu. V takomto prípade sa mu v  CRA-CR a CRA-RU označí riadok „akceptuje nejakú zodpovednosť ale minimalizuje (bagatelizuje) a/alebo racionalizuje (zdôvodňuje)“.",
          "2. Odsúdený je vo VT za nebezpečné vyhrážanie. Skutok priznáva, no bagatelizuje tým, že bol opitý a že to tak určite nemyslel. V CRA-CR a CRA-RU označí riadok „akceptuje nejakú zodpovednosť ale minimalizuje (bagatelizuje) a/alebo racionalizuje (zdôvodňuje)“."
        ]
      },

      predatorske_spravanie: {
        nazov: "Predátorské správanie",
        poznamka: [],
        charakteristika: [],
        priklad: [],
        zdroj: [
          "Osobné pohovory, poznatky od blízkych, korešpondencia, iné záznamy a pod."
        ]
      },

      plnenie_programu: {
        nazov: "Plnenie programu zaobchádzania",
        charakteristika: [],
        priklad: [],
        zdroj: [
          "Aplikácia VVVT - hodnotenie programu zaobchádzania/IAPSZ platné v čase vypĺňania CRA-CR a CRA-RU."
        ],
        poznamka: [
          "1. Riadok „nehodnotiteľné“ uvádzame v prípade odsúdeného, ktorý v čase podania žiadosti na konanie o podmienečnom prepustení nemá stanovený program zaobchádzania/vypracovaný IAPSZ a nemá určené ani krátkodobé ciele zaobchádzania (po veľmi krátkom čase po nástupe do VTOS si podáva žiadosť na PP, často ešte počas pobytu v ústave na výkon väzby).",
          "2. V prípade odsúdeného s trestom kratším ako 9 mesiacov hodnotíme krátkodobé ciele zaobchádzania."
        ]
      },

      rodina_a_vztahy: {
        nazov: "Rodina a vzťahy počas aktuálneho výkonu trestu odňatia slobody",
        priklad: [],
        charakteristika: [
          "- „Udržiava kontakt...pričom tento kontakt možno charakterizovať ako intenzívny a pravidelný“ znamená, že vzťah sa javí ako hlboký, kvalitný, podporný, úprimný a nie je založený iba na získaní osobného prospechu.",
          "- „Udržiava kontakt...“ znamená, že vzťah odsúdeného sa viac javí ako povrchný, s prvkami manipulácie.  Obsahom jeho korešpondencie sú často požiadavky (balíky, peniaze), výčitky, obviňovanie."
        ],
        poznamka: [
          "- V CRA-CR a CRA-RU označíme riadok „Udržiava kontakt“ aj v tých prípadoch, kedy odsúdený má snahu, ale nedostáva odpoveď od rodiny z dôvodov ktoré nemajú nepriateľský alebo odmietavý charakter (finančné, zdravotné, sociálne a pod.). Vzťah s rodinou pretrváva (preverené sociálnym pracovníkom).",
          "- V CRA-CR a CRA-RU označíme riadok „Nemá kontakt“ aj v tých prípadoch, kedy odsúdený má snahu o kontakt, ale rodina nejaví záujem z dôvodov, ktoré majú nepriateľský alebo odmietavý charakter (napr. z dôvodu spáchaného trestného činu voči nim) - týmto riadkom označíme aj odsúdeného, ktorý nemá žiadne blízke osoby."
        ],
        zdroj: [
          "Osobné pohovory, poznatky od blízkych, korešpondencia, iné záznamy, telefonovanie, financie, balíky a pod."
        ]
      },

      expertne_posudenie: {
        nazov:
          "Expertné posúdenie - pravdepodobnosť, že posudzovaná osoba sa dopustí trestnej činnosti do 2 rokov od prepustenia",
        priklad: [],
        zdroj: [],
        poznamka: [],
        charakteristika: [
          "Expertné posúdenie znamená komplexné hodnotenie, ktoré je založené na teoretických znalostiach a praktických skúsenostiach hodnotiteľa – poskytuje odpoveď na otázku „Aká je z Vášho profesionálneho pohľadu na odsúdeného pravdepodobnosť jeho opakovaného zlyhania (trestnej činnosti) v najbližších dvoch rokoch?“"
        ]
      }
    }
  }),

  computed: {
    color() {
      if (this.form.expertne_posudenie == 0) return "grey";
      if (this.form.expertne_posudenie == 1) return "green";
      if (this.form.expertne_posudenie == 2) return "orange";
      if (this.form.expertne_posudenie == 3) return "red";
      return "grey";
    }
  },

  created() {
    this.getPenitenciarneZaobchadzanie();
  },

  methods: {
    appendIconCallback(nazov) {
      this.dialog = true;
      this.dialog_item = this.manual[nazov];
    },
    clear() {
      this.form.id = null;
      this.form.skore = 0;
      this.form.disciplinarne_tresty = "";
      this.form.disciplinarne_odmeny = "";
      this.form.zamietnute_ziadosti_o_podm = "";
      this.form.prijatie_zodpovednosti = "";
      this.form.predatorske_spravanie = "";
      this.form.plnenie_programu = "";
      this.form.rodina_a_vztahy = "";
      this.form.expertne_posudenie = "";
    },
    getPenitenciarneZaobchadzanie() {
      apiService
        .getPenitenciarneZaobchadzanie(this.$route.params.id)
        .then(response => {
          this.form = response;
        });
      apiService.getCraForm(this.$route.params.id).then(response => {
        this.craItem = response;
      });
    },
    updateItem() {
      apiService
        .updatePenitenciarneZaobchadzanie(this.form, this.$route.params.id)
        .then(
          () => {
            this.snackbar_saved = true;
          },
          () => {
            this.snackbar_error = true;
          }
        );
    },
    openItem() {
      apiService
        .updatePenitenciarneZaobchadzanie(
          { id: this.form.id, closed: false },
          this.$route.params.id
        )
        .then(
          response => {
            this.snackbar_saved = true;
            this.form = response;
          },
          () => {
            this.snackbar_error = true;
          }
        );
    },

    closeItem() {
      this.$validator.validateAll().then(valid => {
        if (valid) {
          if (
            confirm(
              "Naozaj chcete uložiť a uzatvoriť túto časť formulára? (Následne nebude možné už formulár upravovať)"
            )
          ) {
            this.form.closed = true;

            apiService
              .updatePenitenciarneZaobchadzanie(
                this.form,
                this.$route.params.id
              )
              .then(
                response => {
                  this.snackbar_saved = true;
                  this.form = response;
                },
                () => {
                  this.snackbar_error = true;
                }
              );
          }
        } else {
          alert("Všetky položky musia byť vyplnené.");
        }
      });
    }
  }
};
</script>
